export const hipPainText = {
  values: [
    { value: 'HipPain_nota', text: 'Ikke aktuelt', score: 0 },
    { value: 'HipPain_lat', text: 'Lateralt', score: 0 },
    { value: 'HipPain_med', text: 'Medial/lyske', score: 0 },
    { value: 'HipPain_post', text: 'Posteriort', score: 0 },
    { value: 'HipPain_ant', text: 'Anteriort', score: 0 },
  ],
};
